var _path, _path2, _path3, _path4, _circle, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 91,
    viewBox: "0 0 141 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3198 87.2229L15.9154 80.6881L10.0032 83.1297L12.3198 87.2229Z",
    stroke: "#07EFB8",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M129.121 84L124 77L135 82.0207L129.121 84Z",
    stroke: "#07EFB8",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8102 22.616C5.36223 22.616 6.62041 21.3588 6.62041 19.808C6.62041 18.2572 5.36223 17 3.8102 17C2.25817 17 1 18.2572 1 19.808C1 21.3588 2.25817 22.616 3.8102 22.616Z",
    stroke: "#07EFB8",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119 1C120.57 1 120.57 2 122.142 2C123.714 2 123.714 1 125.285 1C126.855 1 126.855 2 128.427 2C129.999 2 129.997 1 131.569 1C133.141 1 133.141 2 134.712 2C136.282 2 136.284 1 137.856 1C139.428 1 139.428 2 141 2",
    stroke: "#07EFB8",
    strokeMiterlimit: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 48,
    r: 43,
    fill: "#07EFB8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94 33L63.2308 64L54 54.7093",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success_icon.2a77f053962a292a25d3c3354b335eed.svg";
export { ForwardRef as ReactComponent };